import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@linaria/react';
import { COLORS, Icon, typographyStyles } from '@livecommerce/design-system';

const { getBodyText } = typographyStyles;

const SearchInput = styled.input`
  appearance: none;
  border: 0;
  border-radius: 100px;
  color: ${COLORS.blackLight};
  background-color: transparent;
  padding: 10px 0 10px 36px;
  ${getBodyText(16)};

  width: ${(props) => props.width};
  transition: background-color 0.25s ease-in-out, padding-left 0.25s ease-in-out, width 0.25s ease-in-out;

  &::placeholder {
    color: ${COLORS.greyMediumDark};
  }

  &:hover {
    background-color: ${COLORS.greyLight};

    padding-left: 42px;
    padding-right: 20px;
    width: 100%;

    & + svg {
      transform: translateY(-50%) translateX(6px);
    }
  }

  &:hover:focus,
  &:focus {
    background-color: ${COLORS.greyLight};
    padding-left: 48px;
    padding-right: 20px;
    width: 100%;

    & + svg {
      transform: translateY(-50%) translateX(12px);
    }
  }
`;

const SearchWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background-color: transparent;
`;

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  order: -1;
  transition: transform 0.25s ease-in-out;
`;

const Search = ({ width = 'auto', className, ...props }, ref) => {
  return (
    <SearchWrapper className={className}>
      <SearchInput type="search" width={width} {...props} ref={ref} />
      <StyledIcon name="search" />
    </SearchWrapper>
  );
};

const SearchRef = forwardRef(Search);

SearchRef.propTypes = {
  width: PropTypes.string,
  className: PropTypes.string,
};

export default SearchRef;
